// =============================================================================
// FILE:
// frontend/src/modules/pms/task_execution/pages/TaskExecutionWorkbenchPage.js
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";

import TaskExecutionHeader
from "../components/TaskExecutionHeader";

import TaskExecutionKPISection
from "../components/TaskExecutionKPISection";

import TaskExecutionFilterPanel
from "../components/TaskExecutionFilterPanel";

import TaskGrid
from "../components/TaskGrid";

import TaskExecutionDrawer
from "../drawers/TaskExecutionDrawer";

import {
  getMyTasksWorkbench
} from "../services/taskExecutionService";


// =============================================================================
// COMPONENT
// =============================================================================

export default function TaskExecutionWorkbenchPage() {


  // ===========================================================================
  // STATE
  // ===========================================================================
  const [loading, setLoading] =
    useState(false);


  const [rows, setRows] =
    useState([]);


  const [selectedTask, setSelectedTask] =
    useState(null);


  const [drawerOpen, setDrawerOpen] =
    useState(false);


  const [filters, setFilters] =
    useState({

      project_id: "",

      phase_id: "",

      status: "",

      priority: "",

      search: ""
    });


  const [kpis, setKpis] =
    useState({

      assigned_tasks: 0,

      ready_tasks: 0,

      in_progress_tasks: 0,

      blocked_tasks: 0,

      completed_tasks: 0
    });


  // ===========================================================================
  // LOAD
  // ===========================================================================
  useEffect(() => {

    loadWorkbench();

  }, []);


  // ===========================================================================
  // LOAD WORKBENCH
  // ===========================================================================
  const loadWorkbench =
    async () => {

      try {

        setLoading(true);


        // ---------------------------------------------------------------
        // LIVE API
        // ---------------------------------------------------------------
        const response =
          await getMyTasksWorkbench(
            filters
          );


        // ---------------------------------------------------------------
        // RESPONSE SAFETY
        // ---------------------------------------------------------------
        const payload =
          response?.data || {};


        const workbench =
          payload?.data || {};


        setRows(
          workbench?.rows || []
        );


        setKpis(
          workbench?.kpis || {

            assigned_tasks: 0,

            ready_tasks: 0,

            in_progress_tasks: 0,

            blocked_tasks: 0,

            completed_tasks: 0
          }
        );

      } catch (err) {

        console.error(
          "Failed to load workbench",
          err
        );

      } finally {

        setLoading(false);
      }
    };


  // ===========================================================================
  // FILTER CHANGE
  // ===========================================================================
  const handleFilterChange =
    (field, value) => {

      setFilters((prev) => ({

        ...prev,

        [field]: value
      }));
    };


  // ===========================================================================
  // APPLY FILTER
  // ===========================================================================
  const handleApplyFilters =
    async () => {

      await loadWorkbench();
    };


  // ===========================================================================
  // ROW CLICK
  // ===========================================================================
  const handleRowClick =
    async (row) => {

      try {

        setLoading(true);

        // -------------------------------------------------------------
        // TEMP MOCK ENRICHMENT
        // -------------------------------------------------------------
        setSelectedTask({

          ...row,

          total_materials: 12,

          approved_requests: 3,

          total_issues: 5,

          readiness_percent:
            row.readiness_percent || 0
        });

        setDrawerOpen(true);

      } catch (err) {

        console.error(
          "Failed to load task details",
          err
        );

      } finally {

        setLoading(false);
      }
    };


  // ===========================================================================
  // RENDER
  // ===========================================================================
  return (

    <div style={styles.page}>


      <TaskExecutionHeader />


      <TaskExecutionKPISection
        kpis={kpis}
      />


      <TaskExecutionFilterPanel

        filters={filters}

        onChange={handleFilterChange}

        onApply={handleApplyFilters}
      />


      <TaskGrid

        rows={rows}

        loading={loading}

        onRowClick={handleRowClick}
      />


      <TaskExecutionDrawer

        open={drawerOpen}

        task={selectedTask}

        onClose={() => {

          setDrawerOpen(false);

          setSelectedTask(null);
        }}
      />

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  page: {

    padding: 20,

    background: "#f3f4f6",

    minHeight: "100vh"
  }
};